import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '@services/session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private SessionService: SessionService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                    console.error('[Auth] HTTP', error.status, '— a invalidar sessão');
                    this.SessionService.TriggerSessionLoss();
                }
                return throwError(() => error);
            })
        );
    }
}
